<script lang="ts">
  import { writable } from "svelte/store"
  import ScrollSnap from "./utils/ScrollSnap.svelte"
  import { setContext } from "./utils/context"

  export let id: string | undefined = undefined

  const context = writable({ selected: 0, count: 1 })

  if (id) setContext(id, context)
</script>

<ScrollSnap {...$$restProps} bind:selected={$context.selected} bind:length={$context.count}>
  <slot />
</ScrollSnap>
